export class ToastElem {
  severity: string;
  message: string;

  constructor(message: string, severity: string = 'primary') {
    this.message = message;
    this.severity = severity;
  }
}
